import React, { useEffect, useState } from 'react';
import CommonModal from '../modalLayout/CommonModal';
import Form from 'react-bootstrap/Form';
import Button from '../buttons/button';
import {
  useCreateFaqCategoryMutation,
  useUpdateFaqCategoryMutation,
  useGetFaqCategoryByIdQuery,
} from '../../../app/faqApi/faqApi';
import { showToast } from '../../../helpers/Utils';

const AddFaqCategoryModal = ({ show, setShow, handleClose, editId }) => {
  const [formData, setFormData] = useState({ name: '' });

  const [createFaqCategory, { isLoading: isCreating }] = useCreateFaqCategoryMutation();
  const [updateFaqCategory, { isLoading: isUpdating }] = useUpdateFaqCategoryMutation();

  const {
    data: editData,
    isFetching: isFetchingCategory,
  } = useGetFaqCategoryByIdQuery(editId, { skip: !editId });

  // Reset formData when modal opens or editId changes
  useEffect(() => {
    if (editId && editData?.data) {
      setFormData({ name: editData.data.name || '' });
    } else if (!editId) {
      setFormData({ name: '' });
    }
  }, [editId, editData, show]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      showToast('Category name is required', 'error');
      return;
    }

    try {
      if (editId) {
        await updateFaqCategory({ categoryId: editId, ...formData }).unwrap();
        showToast('Category updated successfully', 'success');
      } else {
        await createFaqCategory(formData).unwrap();
        showToast('Category added successfully', 'success');
      }

      handleClose();
    } catch (err) {
      showToast(err?.data?.message || 'Something went wrong', 'error');
    }
  };

  return (
    <CommonModal
      show={show}
      setShow={setShow}
      handleClose={handleClose}
      title={editId ? 'Edit FAQ Category' : 'Add FAQ Category'}
    >
      {editId && isFetchingCategory ? (
        <div className="text-center py-4">Loading category...</div>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Category Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter category name"
              value={formData.name}
              onChange={(e) => setFormData({ name: e.target.value })}
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-3">
            <Button label="Cancel" className="borderedBtn" onClick={handleClose} />
            <Button type="submit" label={isCreating || isUpdating ? 'Saving...' : 'Save'} />
          </div>
        </Form>
      )}
    </CommonModal>
  );
};

export default AddFaqCategoryModal;
